import theme from './theme'

const hex2RGBA = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export const mapContainerStyles = {
  position: 'relative',
  height: 500,
  maxHeight: 500,
};

export const mapCardStyles = {
  margin: '0 auto',
  padding: window.innerWidth > 768 ? '40px 32px 32px' : '30px 20px 20px',
  maxWidth: '1200px',
};

export const polygonColorsFabric = {
  activeColor: function (opacity) {
    return hex2RGBA(theme.DARK_BLUE_MAP, opacity);
  },
  adjacentColor: function (opacity, qualified = false) {
    return hex2RGBA((qualified ? theme.ORANGE : theme.GRAY), opacity);
  },
}

export const polygonColors = {
  active: polygonColorsFabric.activeColor(1),
  adjacent: polygonColorsFabric.adjacentColor(1),
  adjacentQualified: polygonColorsFabric.adjacentColor(1, true),
  inView: theme.LIGHT_BLUE
};

export const polygonOpacity = {
  active: .5,
  adjacent: .4,
  inView: .3,
}

export const strokeStyle = {
  weight: 2,
  color: theme.DARK_BLUE_BORDER,
  inViewColor: theme.GRAY_LIGHT_1
};
